import template from './onboardingAdditionalStaff.html';
import controller from './onboardingAdditionalStaffCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    readOnly: '<',
  },
};
